import { Injectable, Injector } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { HttpService } from "app/services/base/http.service";
import { consultInterface } from "api-interface/consult.interface";
import { ConsultListModel } from "app/model/consult.list.model";
import { ConsulterModel } from "app/model/consulter.model";
import { ConsultantModel } from "app/model/consultant.model";
import { environment } from "environments/environment";



@Injectable()
export class ConsultService extends HttpService {

    constructor(private injector: Injector) {
        super(injector);
    }

    /**
     * 相談一覧を取得する
     */
    public async getConsults(): Promise<Array<ConsultListModel>> {

        return await this.get<Array<consultInterface.GetRes>>('/consult');
    }


    /**
     * 相談情報を取得する
     * 
     * @param referenceNum 整理番号
     */
    public async getConsulter(referenceNum: string, referencePassword?: string): Promise<{status: string; title: string;} & ConsulterModel> {

        let params = null;
        if (referencePassword) {
            params = {referencePassword: referencePassword};
        }

        let consulter = await this.get<consultInterface.consulter.GetRes>('/consult/' + referenceNum + '/consulter', params);
        return consulter;
    }

    /**
     * 相談情報を登録する
     * 
     * @param consulter 相談者フォーム
     */
    public async createConsulter(consulter: ConsulterModel, recaptcha: string) {

        let postBody: consultInterface.consulter.PostReq = Object.assign(consulter, {recaptcha: recaptcha});

        await this.post('/consult', postBody );
    }



    /**
     * 事実確認情報を取得する
     * 
     * @param referenceNum 整理番号
     */
    public async getConsultant(referenceNum: string): Promise<ConsultantModel> {
        let consultant: ConsultantModel = await this.get<consultInterface.consultant.GetRes>('/consult/' + referenceNum + '/consultant');
        return consultant;
    }



    /**
     * 事実確認情報を更新する
     * 
     * @param referenceNum 整理番号
     * @param consultantModel 相談窓口者フォーム
     */
    public async updateConsultant(referenceNum: string, consultantModel: ConsultantModel, allDone: boolean) {
        let reqData = Object.assign(consultantModel, {allDone: allDone});
        await this.put('/consult/' + referenceNum + '/consultant', reqData);
    }


}


// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/services/consult/consult.service.ts